import { Component, Input } from '@angular/core';
import { IxFilterItemHeaderComponent } from 'ix-ng-components';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-filter-header',
  templateUrl: './vpo-filter-header.component.html',
  imports: [NgClass],
})
export class VpoFilterHeaderComponent extends IxFilterItemHeaderComponent {
  @Input()
  hideButton = false;

  @Input()
  isNumberFormat = false;

  onClickAction(event: Event) {
    if (this.isNumberFormat) {
      this.onClickDown(event);
    } else {
      this.onClick(event);
    }
  }
}
